const _ = require('./enum');
const PaymentMethodTypes = require('./paymentMethodTypes/enum');
const Schemes = require('../schemes/enum');

const ComponentTypes = {
  CARD: 'card',
  FORM_REDIRECT: 'form_redirect',
  NO_FORM_REDIRECT: 'no_form_redirect',
};

const DeviceTypes = require('../transaction/deviceTypes/enum');

const paymentMethods = {
  [_.NORBRPAY]: {
    code: 131,
    name: 'Norbrpay',
    label: 'Norbrpay',
    type: PaymentMethodTypes.INSTANT_PAYMENT,
    scheme: Schemes._,
    api_name: _.NORBRPAY,
    id: _.NORBRPAY,
    countries: ['NL', 'FR', 'GB', 'IT', 'ES', 'DE'],
    logo: 'norbrpay.svg',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
  },
  [_.SATISPAY]: {
    code: 133,
    name: 'Satispay',
    label: 'Satispay',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.SATISPAY,
    id: _.SATISPAY,
    countries: ['IT'],
    is_available: true,
    logo: 'satispay.svg',
    logo_png: 'satispay.png',
    logo_colorbg: 'Satispay_colorbg.svg',
    logo_colorbg_png: 'Satispay_colorbg@2x.png',
    logo_favicon_colorbg: 'Satispay_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Satispay_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Satispay_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Satispay_favicon_whitebg@2x.png',
    logo_white: 'Satispay_white.svg',
    logo_white_png: 'Satispay_white@2x.png',
    logo_whitebg: 'Satispay_whitebg.svg',
    logo_whitebg_png: 'Satispay_whitebg@2x.png',
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.BLIK]: {
    code: 134,
    name: 'Blik',
    label: 'Blik',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.BLIK,
    id: _.BLIK,
    countries: ['PL'],
    is_available: true,
    logo: 'blik.svg',
    logo_png: 'blik.png',
    logo_colorbg: 'Blik_colorbg.svg',
    logo_colorbg_png: 'Blik_colorbg@2x.png',
    logo_favicon_colorbg: 'Blik_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Blik_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Blik_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Blik_favicon_whitebg@2x.png',
    logo_white: 'Blik_white.svg',
    logo_white_png: 'Blik_white@2x.png',
    logo_whitebg: 'Blik_whitebg.svg',
    logo_whitebg_png: 'Blik_whitebg@2x.png',
    api_required_fields: ['payment_method_name', 'amount', 'currency', 'customer_first_name', 'customer_last_name', 'customer_email'],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.GOOGLEPAY]: {
    code: 135,
    name: 'Google Pay',
    label: 'Google Pay',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.GOOGLEPAY,
    id: _.GOOGLEPAY,
    countries: [
      'AL',
      'DZ',
      'AS',
      'AO',
      'AG',
      'AR',
      'AU',
      'AT',
      'AZ',
      'BH',
      'BY',
      'BE',
      'BR',
      'BG',
      'CA',
      'CL',
      'CO',
      'HR',
      'CZ',
      'DK',
      'DO',
      'EG',
      'EE',
      'FI',
      'FR',
      'DE',
      'GR',
      'HK',
      'HU',
      'IN',
      'ID',
      'IE',
      'IL',
      'IT',
      'JP',
      'JO',
      'KZ',
      'KE',
      'KW',
      'LV',
      'LB',
      'LT',
      'LU',
      'MY',
      'MX',
      'NL',
      'NZ',
      'NO',
      'OM',
      'PK',
      'PA',
      'PE',
      'PH',
      'PL',
      'PT',
      'QA',
      'RO',
      'RU',
      'SA',
      'SG',
      'SK',
      'ZA',
      'ES',
      'LK',
      'SE',
      'CH',
      'TW',
      'TH',
      'TR',
      'UA',
      'AE',
      'UK',
      'US',
      'UY',
      'VN',
    ],
    is_available: true,
    logo: 'google_pay.svg',
    logo_png: 'google_pay.png',
    logo_colorbg: 'GooglePay_colorbg.svg',
    logo_colorbg_png: 'GooglePay_colorbg@2x.png',
    logo_favicon_colorbg: 'GooglePay_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'GooglePay_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'GooglePay_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'GooglePay_favicon_whitebg@2x.png',
    logo_white: 'GooglePay_white.svg',
    logo_white_png: 'GooglePay_white@2x.png',
    logo_whitebg: 'GooglePay_whitebg.svg',
    logo_whitebg_png: 'GooglePay_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.VOLT]: {
    code: 126,
    name: 'Volt',
    label: 'Volt',
    type: PaymentMethodTypes.INSTANT_PAYMENT,
    scheme: Schemes._,
    api_name: _.VOLT,
    id: _.VOLT,
    countries: ['NL', 'FR', 'GB', 'IT', 'ES', 'DE'],
    logo: 'volt.svg',
    logo_png: 'volt.png',
    logo_colorbg: 'Volt_colorbg.svg',
    logo_colorbg_png: 'Volt_colorbg@2x.png',
    logo_favicon_colorbg: 'Volt_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Volt_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Volt_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Volt_favicon_whitebg@2x.png',
    logo_white: 'Volt_white.svg',
    logo_white_png: 'Volt_white@2x.png',
    logo_whitebg: 'Volt_whitebg.svg',
    logo_whitebg_png: 'Volt_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
  },
  [_.GIROCARD]: {
    code: 104,
    name: 'Girocard',
    label: 'Girocard',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.GIROCARD,
    api_name: _.GIROCARD,
    id: _.GIROCARD,
    countries: ['DE'],
    is_available: false,
  },
  [_.MYBANK]: {
    code: 103,
    name: 'MyBank',
    label: 'MyBank',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.MYBANK,
    id: _.MYBANK,
    countries: ['IT'],
    is_available: true,
    logo: 'mybank.svg',
    logo_png: 'mybank.png',
    logo_colorbg: 'Mybank_colorbg.svg',
    logo_colorbg_png: 'Mybank_colorbg@2x.png',
    logo_favicon_colorbg: 'Mybank_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Mybank_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Mybank_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Mybank_favicon_whitebg@2x.png',
    logo_white: 'Mybank_white.svg',
    logo_white_png: 'Mybank_white@2x.png',
    logo_whitebg: 'Mybank_whitebg.svg',
    logo_whitebg_png: 'Mybank_whitebg@2x.png',
    api_required_fields: ['payment_method_name', 'amount', 'currency', 'account_bic'],
    api_form_fields: [
      {
        name: 'account_bic',
        label: 'account_bic',
        display_name: 'Bank name',
        data_type: 'string',
        enum: [
          {
            key: 'CT000005',
            value: 'SUEDTIROLER VOLKSBANK',
          },
          {
            key: 'CT000005',
            value: 'VOLKSBANK',
          },
          {
            key: 'CT000005',
            value: 'BANCA POPOLARE DELL ALTO ADIGE',
          },
          {
            key: 'CT000005',
            value: 'VOLKSBANK - BANCA POPOLARE',
          },
          {
            key: 'CT000009',
            value: 'RAIFFEISEN ALTO ADIGE',
          },
          {
            key: 'CT000009',
            value: 'RAIFFEISEN SUEDTIROL',
          },
          {
            key: 'CT000006',
            value: 'BANCA POPOLARE DI SONDRIO',
          },
          {
            key: 'CT000037',
            value: 'UNICREDIT - ONLINE BANKING',
          },
          {
            key: 'CT000038',
            value: 'ALLIANZ BANK FINANCIAL ADVISORS SPA',
          },
          {
            key: 'CT000040',
            value: 'ICCREA BANCA S.P.A.',
          },
          {
            key: 'CT000061',
            value: 'BANCA DEL PIEMONTE',
          },
          {
            key: 'CT000065',
            value: 'CASSA CENTRALE BANCA',
          },
          {
            key: 'CT000068',
            value: 'BANCA DI BOLOGNA',
          },
          {
            key: 'CT000070',
            value: 'BCC LA RISCOSSA DI REGALBUTO',
          },
          {
            key: 'CT000074',
            value: 'BANCA ADRIA COLLI EUGANEI',
          },
          {
            key: 'CT000076',
            value: 'ZKB CRED.COOP.DI TRIESTE E GORIZIA',
          },
          {
            key: 'CT000082',
            value: 'BCC BRESCIA',
          },
          {
            key: 'CT000084',
            value: 'BVR BANCA BANCHE VENETE RIUNITE',
          },
          {
            key: 'CT000085',
            value: 'PRIMACASSA FVG',
          },
          {
            key: 'CT000086',
            value: 'CASSA RURALE FVG',
          },
          {
            key: 'CT000088',
            value: 'CRA CORTINA DI AMPEZZO',
          },
          {
            key: 'CT000089',
            value: 'BCC CONVERSANO',
          },
          {
            key: 'CT000090',
            value: 'BCC ANAGNI',
          },
          {
            key: 'CT000094',
            value: 'CASSA DI TRENTO',
          },
          {
            key: 'CT000095',
            value: 'CASSA RURALE VAL DI NON',
          },
          {
            key: 'CT000105',
            value: 'CASSA RURALE NOVELLA E ALTA ANAUNIA',
          },
          {
            key: 'CT000107',
            value: 'CASSA RURALE VAL DI FIEMME',
          },
          {
            key: 'CT000109',
            value: 'CASSA RURALE ALTA VALSUGANA',
          },
          {
            key: 'CT000113',
            value: 'CASSA RURALE DOLOMITI',
          },
          {
            key: 'CT000114',
            value: 'CASSA RURALE ROTALIANA E GIOVO',
          },
          {
            key: 'CT000120',
            value: 'CASSA RURALE VALSUGANA E TESINO',
          },
          {
            key: 'CT000125',
            value: 'LA CASSA RURALE',
          },
          {
            key: 'CT000130',
            value: 'CASSA RURALE DI LEDRO',
          },
          {
            key: 'CT000132',
            value: 'CASSA RURALE ALTO GARDA - ROVERETO',
          },
          {
            key: 'CT000134',
            value: 'CASSA RURALE VALLAGARINA',
          },
          {
            key: 'CT000136',
            value: 'CREDITO LOMBARDO VENETO',
          },
          {
            key: 'CT000150',
            value: 'BANCA FINNAT EURAMERICA SPA',
          },
          {
            key: 'CT000149',
            value: 'IMPREBANCA SPA',
          },
          {
            key: 'CT000148',
            value: 'BANCA DI PIACENZA SCPA',
          },
          {
            key: 'CT000147',
            value: 'BANCA POPOLARE PUGLIESE',
          },
          {
            key: 'CT000146',
            value: 'BANCA POPOLARE VALCONCA SCPA',
          },
          {
            key: 'CT000142',
            value: 'BANCA POPOLARE DEL LAZIO SCPA',
          },
          {
            key: 'CT000151',
            value: 'INTESA SANPAOLO PRIVATE BANKING SPA',
          },
          {
            key: 'CT000152',
            value: 'LA CASSA DI RAVENNA SPA',
          },
          {
            key: 'CT000153',
            value: 'BANCA SISTEMA SPA',
          },
          {
            key: 'CT000155',
            value: 'BANCA FIDEURAM',
          },
          {
            key: 'CT000158',
            value: 'BANCA VALSABBINA',
          },
          {
            key: 'CT000161',
            value: 'BANCO BPM SPA - SERVIZIO YOUWEB',
          },
          {
            key: 'CT000165',
            value: 'BANCA GENERALI SPA',
          },
          {
            key: 'CT000166',
            value: 'CASSA DI RISPARMIO DI FERMO SPA',
          },
          {
            key: 'CT000168',
            value: 'BANCA DI IMOLA SPA',
          },
          {
            key: 'CT000175',
            value: 'CHIANTIBANCA - CREDITO COOPERATIVO',
          },
          {
            key: 'CT000179',
            value: 'B.C.C. SAN GIUSEPPE DI MUSSOMELI',
          },
          {
            key: 'CT000177',
            value: 'BANCA DELLA MARCA CRED.COOPERATIVO',
          },
          {
            key: 'CT000180',
            value: 'BANCA SVILUPPO COOPERAZ. CREDITO',
          },
          {
            key: 'CT000181',
            value: 'BCC BELLEGRA',
          },
          {
            key: 'CT000182',
            value: 'BCC TRIUGGIO VALLE DEL LAMBRO',
          },
          {
            key: 'CT000185',
            value: 'BCC PRATOLA PELIGNA',
          },
          {
            key: 'CT000186',
            value: 'BCC AGRO PONTINO',
          },
          {
            key: 'CT000187',
            value: 'BCC VICENTINO POJANA MAGGIORE',
          },
          {
            key: 'CT000188',
            value: 'BCC DI GAMBATESA',
          },
          {
            key: 'CT000201',
            value: 'BCC VERSILIA LUNIGIANA E GARFAGNANA',
          },
          {
            key: 'CT000202',
            value: 'BCC NETTUNO',
          },
          {
            key: 'CT000204',
            value: 'BCC AGRO BRESCIANO',
          },
          {
            key: 'CT000206',
            value: 'BANCA DELLE TERRE VENETE',
          },
          {
            key: 'CT000207',
            value: 'BCC CAMPANIA CENTRO',
          },
          {
            key: 'CT000208',
            value: 'BCC BRIANZA E LAGHI',
          },
          {
            key: 'CT000210',
            value: 'CREDITO COOPERATIVO AGRIGENTINO',
          },
          {
            key: 'CT000212',
            value: 'BANCA DI TARANTO BCC',
          },
          {
            key: 'CT000213',
            value: 'EMILBANCA C.C.',
          },
          {
            key: 'CT000214',
            value: 'CREDITO COOPERATIVO ROMAGNOLO',
          },
          {
            key: 'CT000203',
            value: 'BCC VALLE DEL TORTO',
          },
          {
            key: 'CT000217',
            value: 'UNICREDIT - UNIWEB CORPORATE',
          },
          {
            key: 'CT000219',
            value: 'BCC G. TONIOLO DI SAN CATALDO',
          },
          {
            key: 'CT000222',
            value: 'BCC SAN BIAGIO PLATANI',
          },
          {
            key: 'CT000226',
            value: 'BCC DI GAUDIANO DI LAVELLO',
          },
          {
            key: 'CT000227',
            value: 'BCC RAVENNA FORLI IMOLA',
          },
          {
            key: 'CT000228',
            value: 'BANCA ALPI MARITTIME - CC CARRU',
          },
          {
            key: 'CT000229',
            value: 'BCC DI CARAVAGGIO',
          },
          {
            key: 'CT000231',
            value: 'BCC DI ARBOREA',
          },
          {
            key: 'CT000233',
            value: 'BCC DI BARI',
          },
          {
            key: 'CT000264',
            value: 'BANCA DI PESARO',
          },
          {
            key: 'CT000267',
            value: 'BCC DI ALTOFONTE E CACCAMO',
          },
          {
            key: 'CT000268',
            value: 'BCC MILANO',
          },
          {
            key: 'CT000271',
            value: 'CRA DI PALIANO',
          },
          {
            key: 'CT000272',
            value: 'BCC DI SCAFATI E CETARA',
          },
          {
            key: 'CT000273',
            value: 'CASSA RURALE DI TREVIGLIO',
          },
          {
            key: 'CT000274',
            value: 'BANCA DON RIZZO',
          },
          {
            key: 'CT000275',
            value: 'BCC DELLE MADONIE',
          },
          {
            key: 'CT000277',
            value: 'BANCA DI ALBA CREDITO COOPERATIVO',
          },
          {
            key: 'CT000280',
            value: 'CREDITO COOPERATIVO MEDIOCRATI',
          },
          {
            key: 'CT000278',
            value: 'BCC DI BINASCO',
          },
          {
            key: 'CT000279',
            value: 'BCC DI ROMA',
          },
          {
            key: 'CT000281',
            value: 'CENTROMARCA BANCA',
          },
          {
            key: 'CT000172',
            value: 'BANCA MONTE DEI PASCHI DI SIENA',
          },
          {
            key: 'CT000172',
            value: 'MPS',
          },
          {
            key: 'CT000285',
            value: 'BCC DI PACHINO',
          },
          {
            key: 'CT000290',
            value: 'CREDITO DI ROMAGNA',
          },
          {
            key: 'CT000290',
            value: 'SOLUTION BANK',
          },
          {
            key: 'CT000291',
            value: 'CASSA DI RISPARMIO DI SAVIGLIANO',
          },
          {
            key: 'CT000292',
            value: 'CRA - BCC DI CANTU',
          },
          {
            key: 'CT000295',
            value: 'BCC DI PONTASSIEVE',
          },
          {
            key: 'CT000296',
            value: 'BCC DI BUONABITACOLO',
          },
          {
            key: 'CT000297',
            value: 'BCC DI BUSTO GAROLFO E BUGUGGIATE',
          },
          {
            key: 'CT000298',
            value: 'BCC DI FILOTTRANO',
          },
          {
            key: 'CT000301',
            value: 'BANCO BPM SPA - SERVIZIO WEBANK',
          },
          {
            key: 'CT000303',
            value: 'BCC DI OSTRA E MORRO D ALBA',
          },
          {
            key: 'CT000302',
            value: 'B.C.C. DI RECANATI E COLMURANO',
          },
          {
            key: 'CT000313',
            value: 'BCC OGLIO E SERIO',
          },
          {
            key: 'CT000069',
            value: 'ALTO ADIGE BANCA - SUEDTIROL BANK',
          },
          {
            key: 'CT000314',
            value: 'BANCA CENTRO TOSCANA UMBRIA',
          },
          {
            key: 'CT000315',
            value: 'BCC DELLA PROVINCIA ROMANA',
          },
          {
            key: 'CT000316',
            value: 'BANCA PATAVINA',
          },
          {
            key: 'CT000320',
            value: 'BANCA CENTROPADANA',
          },
          {
            key: 'CT000321',
            value: 'BCC CAPACCIO PAESTUM',
          },
          {
            key: 'CT000322',
            value: 'VALPOLICELLA BENACO BANCA',
          },
          {
            key: 'CT000323',
            value: 'BCC DEI COLLI ALBANI',
          },
          {
            key: 'CT000324',
            value: 'BANCA ANNIA',
          },
          {
            key: 'CT000325',
            value: 'BANCA TERRE ETRUSCHE E DI MAREMMA',
          },
          {
            key: 'CT000325',
            value: 'BANCA TEMA',
          },
          {
            key: 'CT000327',
            value: 'BCC DI AQUARA',
          },
          {
            key: 'CT000326',
            value: 'BANCA TERRITORI DEL MONVISO',
          },
          {
            key: 'CT000328',
            value: 'BANCA CENTRO LAZIO',
          },
          {
            key: 'CT000331',
            value: 'BANCA DEL TERRITORIO LOMBARDO',
          },
          {
            key: 'CT000330',
            value: 'BCC DEL VELINO',
          },
          {
            key: 'CT000329',
            value: 'BANCA SICANA',
          },
          {
            key: 'CT000332',
            value: 'BCC DI FLUMERI',
          },
          {
            key: 'CT000333',
            value: 'BCC DEI CASTELLI E DEGLI IBLEI',
          },
          {
            key: 'CT000335',
            value: 'BANCA DEL VENETO CENTRALE',
          },
          {
            key: 'CT000334',
            value: 'BANCO MARCHIGIANO',
          },
          {
            key: 'CT000336',
            value: 'BANCA DI CARAGLIO',
          },
          {
            key: 'CT000342',
            value: 'BCC DI SAN GIOVANNI ROTONDO',
          },
          {
            key: 'CT000343',
            value: 'BCC VALDOSTANA',
          },
          {
            key: 'CT000337',
            value: 'CRA DI BOVES',
          },
          {
            key: 'CT000338',
            value: 'BCC DI BENE VAGIENNA',
          },
          {
            key: 'CT000339',
            value: 'BCC DI CHERASCO',
          },
          {
            key: 'CT000344',
            value: 'BCC DI PIANFEI E ROCCA DE BALDI',
          },
          {
            key: 'CT000346',
            value: 'BANCA CENTRO EMILIA',
          },
          {
            key: 'CT000340',
            value: 'CREDITO ETNEO',
          },
          {
            key: 'CT000347',
            value: 'BANCO BPM SPA - YOUBUSINESS WEB',
          },
          {
            key: 'CT000349',
            value: 'BCC DI SAN MARZANO DI SAN GIUSEPPE',
          },
          {
            key: 'CT000348',
            value: 'FRIULOVEST BANCA',
          },
          {
            key: 'CT000351',
            value: 'BCC DI OSTUNI',
          },
          {
            key: 'CT000350',
            value: 'BCC DI BARLASSINA',
          },
          {
            key: 'CT000352',
            value: 'BCC PREALPI SAN BIAGIO',
          },
          {
            key: 'CT000353',
            value: 'ALTO ADIGE',
          },
          {
            key: 'CT000353',
            value: 'SUEDTIROLER',
          },
          {
            key: 'CT000353',
            value: 'BOZEN',
          },
          {
            key: 'CT000353',
            value: 'CASSA DI RISPARMIO DI BOLZANO',
          },
          {
            key: 'CT000353',
            value: 'SUEDTIROLER SPARKASSE',
          },
          {
            key: 'CT000354',
            value: 'RIVIERA BANCA',
          },
          {
            key: 'CT000357',
            value: 'BCC DI CANOSA - LOCONIA',
          },
          {
            key: 'CT000356',
            value: 'BANCA VERONESE - CC DI CONCAMARISE',
          },
          {
            key: 'CT000358',
            value: 'BCC CASTELLI ROMANI E TUSCOLO',
          },
          {
            key: 'CT000359',
            value: 'BANCATER CREDITO COOP FVG',
          },
          {
            key: 'CT000360',
            value: 'BCC CENTRO CALABRIA',
          },
          {
            key: 'CT000361',
            value: 'BCC DI SPELLO E DEL VELINO',
          },
          {
            key: 'CT000362',
            value: 'BCC MONTE PRUNO',
          },
          {
            key: 'CT000363',
            value: 'BCC ABRUZZI E MOLISE',
          },
          {
            key: 'CT000367',
            value: 'BANCA LAZIO NORD',
          },
          {
            key: 'CT000366',
            value: 'BCC DELLA ROMAGNA OCCIDENTALE',
          },
          {
            key: 'CT000365',
            value: 'BCC DI SANTERAMO IN COLLE',
          },
          {
            key: 'CT000364',
            value: 'BCC ADRIATICO TERAMANO',
          },
          {
            key: 'CT000369',
            value: 'ROMAGNA BANCA',
          },
          {
            key: 'CT000368',
            value: 'BANCA MALATESTIANA',
          },
          {
            key: 'CT000372',
            value: 'BCC DI BUCCINO E COMUNI CILENTANI',
          },
          {
            key: 'CT000371',
            value: 'BANCA DEL CATANZARESE',
          },
          {
            key: 'CT000370',
            value: 'BCC DI S.MARCO DEI CAVOTI',
          },
          {
            key: 'CT000373',
            value: 'BCC GRAN SASSO D ITALIA',
          },
          {
            key: 'CT000376',
            value: 'BANCA DEL CILENTO DI SASSANO E V.',
          },
          {
            key: 'CT000377',
            value: 'RAIFFEISEN SAN MARTINO IN PASSIRIA',
          },
          {
            key: 'CT000378',
            value: 'BCC DI TERRA D OTRANTO',
          },
          {
            key: 'CT000380',
            value: 'BCC LODI.',
          },
          {
            key: 'CT000381',
            value: 'BCC DEGLI ULIVI - TERRA DI BARI',
          },
          {
            key: 'CT000382',
            value: 'BCC DEL CIRCEO E PRIVERNATE',
          },
          {
            key: 'CT000383',
            value: 'BCC ALBEROBELLO SAMMICHELE MONOPOLI',
          },
          {
            key: 'CT000385',
            value: 'DESIO',
          },
          {
            key: 'CT000385',
            value: 'BANCO DESIO BRIANZA',
          },
          {
            key: 'CT000387',
            value: 'BCC DI CAGLIARI',
          },
          {
            key: 'CT000389',
            value: 'BCC DI CASTAGNETO CARDUCCI',
          },
          {
            key: 'CT000388',
            value: 'BCC SAN MICHELE',
          },
          {
            key: 'CT000388',
            value: 'BCC SAN MICHELE DI CALTANISSETTA',
          },
          {
            key: 'CT000388',
            value: 'BCC SAN MICHELE CL E PIETRAPERZIA',
          },
          {
            key: 'CT000390',
            value: 'BANCA AGRICOLA POPOLARE DI RAGUSA',
          },
          {
            key: 'CT000002',
            value: 'SELLA',
          },
          {
            key: 'CT000002',
            value: 'BANCA SELLA',
          },
          {
            key: 'CT000391',
            value: 'BANCA PATRIMONI SELLA',
          },
          {
            key: 'CT000392',
            value: 'BCC DI LEVERANO',
          },
          {
            key: 'CT000111',
            value: 'CASSA RURALE VAL DI SOLE',
          },
          {
            key: 'CT000393',
            value: 'BCC VALDARNO FIORENTINO',
          },
          {
            key: 'CT000394',
            value: 'BANCA DI ANGHIARI E STIA CC',
          },
          {
            key: 'CT000396',
            value: 'CASSA PADANA',
          },
          {
            key: 'CT000403',
            value: 'BCC DI NAPOLI',
          },
          {
            key: 'CT000405',
            value: 'BANCO AZZOAGLIO',
          },
          {
            key: 'CT000407',
            value: 'BANCA DI CREDITO POPOLARE S.C.P.A.',
          },
          {
            key: 'CT000408',
            value: 'BLU BANCA S.P.A.',
          },
          {
            key: 'CT000409',
            value: 'BCC DELL ALTA MURGIA',
          },
          {
            key: 'CT000410',
            value: 'BCC ALTO TIRRENO DELLA CALABRIA',
          },
          {
            key: 'CT000411',
            value: 'CRA DI BORGO SAN GIACOMO',
          },
          {
            key: 'CT000413',
            value: 'BCC FELSINEA',
          },
          {
            key: 'CT000414',
            value: 'BCC  DI LOCOROTONDO',
          },
          {
            key: 'CT000415',
            value: 'BCC DI SARSINA',
          },
          {
            key: 'CT000412',
            value: 'BCC DI CASSANO DELLE MURGE E TOLVE',
          },
          {
            key: 'CT000417',
            value: 'RAIFFEISENKASSE RITTEN',
          },
          {
            key: 'CT000417',
            value: 'CASSA RURALE RENON',
          },
          {
            key: 'CT000418',
            value: 'BANCA DI UDINE CREDITO COOP.',
          },
          {
            key: 'CT000419',
            value: 'BCC DEL GARDA',
          },
          {
            key: 'CT000010',
            value: 'INTESA SANPAOLO',
          },
          {
            key: 'CT000043',
            value: 'INTESA SANPAOLO INBIZ',
          },
          {
            key: 'CT000420',
            value: 'CREDIFRIULI',
          },
          {
            key: 'CT000406',
            value: 'BANCA DI VERONA E VICENZA',
          },
          {
            key: 'CT000421',
            value: 'BCC BASILICATA',
          },
          {
            key: 'CT000401',
            value: 'BANCA ALTA TOSCANA',
          },
          {
            key: 'CT000399',
            value: 'BANCA DI PESCIA E CASCINA',
          },
          {
            key: 'CT000402',
            value: 'BCC PORDENONESE E MONSILE',
          },
          {
            key: 'CT000422',
            value: 'BCC DI PERGOLA E CORINALDO',
          },
          {
            key: 'CT000424',
            value: 'BCC ABRUZZESE CAPPELLE SUL TAVO',
          },
          {
            key: 'CT000425',
            value: 'BANCA  ANNIA',
          },
        ],
        example: 'CT000425',
      },
    ],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    component_type: ComponentTypes.FORM_REDIRECT,
  },
  [_.SWISH]: {
    code: 98,
    name: 'Swish',
    label: 'Swish',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.SWISH,
    id: _.SWISH,
    countries: ['SE'],
    is_available: false,
  },
  [_.PAYSAFECARD]: {
    code: 97,
    name: 'Paysafecard',
    label: 'Paysafecard',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.PAYSAFECARD,
    id: _.PAYSAFECARD,
    countries: ['all'],
    is_available: true,
    logo: 'paysafecard.svg',
    logo_png: 'paysafecard.png',
    logo_colorbg: 'Paysafecard_colorbg.svg',
    logo_colorbg_png: 'Paysafecard_colorbg@2x.png',
    logo_favicon_colorbg: 'Paysafecard_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Paysafecard_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Paysafecard_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Paysafecard_favicon_whitebg@2x.png',
    logo_white: 'Paysafecard_white.svg',
    logo_white_png: 'Paysafecard_white@2x.png',
    logo_whitebg: 'Paysafecard_whitebg.svg',
    logo_whitebg_png: 'Paysafecard_whitebg@2x.png',
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.BANCOMAT]: {
    code: 102,
    name: 'Bancomat',
    label: 'Bancomat',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.BANCOMAT,
    api_name: _.BANCOMAT,
    id: _.BANCOMAT,
    countries: ['IT'],
    is_available: false,
  },
  [_.TROY]: {
    code: 99,
    name: 'Troy',
    label: 'Troy',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.TROY,
    api_name: _.TROY,
    id: _.TROY,
    countries: ['TR'],
    is_available: true,
    logo: 'troy.svg',
    logo_png: 'troy.png',
    logo_colorbg: 'Troy_colorbg.svg',
    logo_colorbg_png: 'Troy_colorbg@2x.png',
    logo_favicon_colorbg: 'Troy_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Troy_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Troy_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Troy_favicon_whitebg@2x.png',
    logo_white: 'Troy_white.svg',
    logo_white_png: 'Troy_white@2x.png',
    logo_whitebg: 'Troy_whitebg.svg',
    logo_whitebg_png: 'Troy_whitebg@2x.png',
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '5436 xxxx xxxx xxxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '123',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    component_type: ComponentTypes.CARD,
  },
  [_.TRUSTLY]: {
    code: 100,
    name: 'Trustly ',
    label: 'Trustly ',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.TRUSTLY,
    id: _.TRUSTLY,
    countries: ['SE', 'NO', 'FI', 'DK', 'DE', 'NL', 'AT'],
    is_available: true,
    logo: 'trustly.svg',
    logo_png: 'trustly.png',
    logo_colorbg: 'Trustly_colorbg.svg',
    logo_colorbg_png: 'Trustly_colorbg@2x.png',
    logo_favicon_colorbg: 'Trustly_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Trustly_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Trustly_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Trustly_favicon_whitebg@2x.png',
    logo_white: 'Trustly_white.svg',
    logo_white_png: 'Trustly_white@2x.png',
    logo_whitebg: 'Trustly_whitebg.svg',
    logo_whitebg_png: 'Trustly_whitebg@2x.png',
    api_form_fields: [
      {
        name: 'customer_identification_number',
        label: 'customer_identification_number',
        display_name: 'Account id',
        data_type: 'integer',
        example: '53033315550',
      },
    ],
    api_required_fields: ['amount', 'currency', 'payment_method_name'],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.VIPPS]: {
    code: 101,
    name: 'Vipps',
    label: 'Vipps',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.VIPPS,
    id: _.VIPPS,
    countries: ['NO'],
    is_available: false,
  },
  [_.GCASH]: {
    code: 87,
    name: 'GCash',
    label: 'GCash',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.GCASH,
    id: _.GCASH,
    countries: ['PH'],
    is_available: false,
  },
  [_.BELFIUS]: {
    code: 90,
    name: 'Belfius',
    label: 'Belfius',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BELFIUS,
    id: _.BELFIUS,
    countries: ['BE'],
    is_available: false,
  },
  [_.RUPAY]: {
    code: 79,
    name: 'Rupay',
    label: 'Rupay',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.RUPAY,
    api_name: _.RUPAY,
    id: _.RUPAY,
    countries: ['IN'],
    is_available: false,
  },
  [_.SISAL]: {
    code: 89,
    name: 'Sisal',
    label: 'Sisal',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.SISAL,
    id: _.SISAL,
    countries: ['IT'],
    is_available: false,
  },
  [_.KONBINI]: {
    code: 86,
    name: 'Konbini',
    label: 'Konbini',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.KONBINI,
    id: _.KONBINI,
    countries: ['JP'],
    is_available: false,
  },
  [_.KBC]: {
    code: 91,
    name: 'KBC / CBC ',
    label: 'KBC / CBC ',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.KBC,
    id: _.KBC,
    countries: ['BE'],
    is_available: false,
  },
  [_.RATEPAY]: {
    code: 84,
    name: 'RatePay',
    label: 'RatePay',
    type: PaymentMethodTypes.OPEN_INVOICE,
    scheme: Schemes._,
    api_name: _.RATEPAY,
    id: _.RATEPAY,
    countries: ['DE', 'CH'],
    is_available: false,
  },
  [_.PAY_BY_LINKS]: {
    code: 85,
    name: 'Pay-by-links',
    label: 'Pay-by-links',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.PAY_BY_LINKS,
    id: _.PAY_BY_LINKS,
    countries: ['PL'],
    is_available: false,
  },
  [_.CITRUS_PAY]: {
    code: 83,
    name: 'CitrusPay',
    label: 'CitrusPay',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.CITRUS_PAY,
    id: _.CITRUS_PAY,
    countries: ['IN'],
    is_available: false,
  },
  [_.DANKORT]: {
    code: 94,
    name: 'Dankort',
    label: 'Dankort',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.DANKORT,
    api_name: _.DANKORT,
    id: _.DANKORT,
    countries: ['DK'],
    is_available: false,
  },
  [_.PAYMAYA_WALLET]: {
    code: 88,
    name: 'PayMaya Wallet',
    label: 'PayMaya Wallet',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.PAYMAYA_WALLET,
    id: _.PAYMAYA_WALLET,
    countries: ['PH'],
    is_available: false,
  },
  [_.MOBIKWIK]: {
    code: 82,
    name: 'MobiKwik',
    label: 'MobiKwik',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.MOBIKWIK,
    id: _.MOBIKWIK,
    countries: ['IN'],
    is_available: false,
  },
  [_.OCA_CARD]: {
    code: 76,
    name: 'oca card',
    label: 'oca card',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.OCA_CARD,
    api_name: _.OCA_CARD,
    id: _.OCA_CARD,
    countries: ['UY'],
    is_available: false,
  },
  [_.UPI]: {
    code: 80,
    name: 'UPI',
    label: 'UPI',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.UPI,
    id: _.UPI,
    countries: ['IN'],
    is_available: false,
  },
  [_.MOBILEPAY_DENMARK]: {
    code: 96,
    name: 'MobilePay Denmark',
    label: 'MobilePay Denmark',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.MOBILEPAY_DENMARK,
    id: _.MOBILEPAY_DENMARK,
    countries: ['DK', 'FI'],
    is_available: false,
  },
  [_.LIDER]: {
    code: 77,
    name: 'Lider',
    label: 'Lider',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.LIDER,
    createdBy: null,
    api_name: _.LIDER,
    id: _.LIDER,
    countries: ['UY'],
    is_available: false,
  },
  [_.PAYU_WALLET]: {
    code: 81,
    name: 'PayU Wallet',
    label: 'PayU Wallet',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.PAYU_WALLET,
    id: _.PAYU_WALLET,
    countries: ['IN'],
    logo: 'payu.svg',
    logo_png: 'payu.png',
    logo_colorbg: 'PayU_colorbg.svg',
    logo_colorbg_png: 'PayU_colorbg@2x.png',
    logo_favicon_colorbg: 'PayU_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'PayU_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'PayU_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'PayU_favicon_whitebg@2x.png',
    logo_white: 'PayU_white.svg',
    logo_white_png: 'PayU_white@2x.png',
    logo_whitebg: 'PayU_whitebg.svg',
    logo_whitebg_png: 'PayU_whitebg@2x.png',
    is_available: false,
  },
  [_.DINERS]: {
    code: 78,
    name: 'Diners club',
    label: 'Diners club',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.DINERS,
    api_name: _.DINERS,
    id: _.DINERS,
    countries: ['SG', 'IN', 'BR', 'NO', 'US'],
    is_available: true,
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '305x xxxxxx xxxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '123',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    component_type: ComponentTypes.CARD,
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    logo: 'diners.svg',
    logo_png: 'diners.png',
    logo_colorbg: 'Diners_colorbg.svg',
    logo_colorbg_png: 'Diners_colorbg@2x.png',
    logo_favicon_colorbg: 'Diners_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Diners_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Diners_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Diners_favicon_whitebg@2x.png',
    logo_white: 'Diners_white.svg',
    logo_white_png: 'Diners_white@2x.png',
    logo_whitebg: 'Diners_whitebg.svg',
    logo_whitebg_png: 'Diners_whitebg@2x.png',
  },
  [_.BANKAXEPT]: {
    code: 93,
    name: 'BankAxept',
    label: 'BankAxept',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BANKAXEPT,
    id: _.BANKAXEPT,
    countries: ['NO'],
    is_available: false,
  },
  [_.AMAZONPAY]: {
    code: 92,
    name: 'AmazonPay ',
    label: 'AmazonPay ',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.AMAZONPAY,
    id: _.AMAZONPAY,
    countries: ['all'],
    is_available: false,
  },
  [_.BANCO_DE_CREDITO]: {
    code: 74,
    name: 'Banco de Credito',
    label: 'Banco de Credito',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BANCO_DE_CREDITO,
    id: _.BANCO_DE_CREDITO,
    countries: ['PE'],
    is_available: false,
  },
  [_.PAGO_EXPRESS]: {
    code: 68,
    name: 'Pago Express',
    label: 'Pago Express',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.PAGO_EXPRESS,
    id: _.PAGO_EXPRESS,
    countries: ['PY'],
    is_available: false,
  },
  [_.PAGO_EFECTIVO]: {
    code: 70,
    name: 'Pago Efectivo',
    label: 'Pago Efectivo',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.PAGO_EFECTIVO,
    id: _.PAGO_EFECTIVO,
    countries: ['PE'],
    is_available: false,
  },
  [_.SCOTIA_BANK]: {
    code: 72,
    name: 'ScotiaBank',
    label: 'ScotiaBank',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.SCOTIA_BANK,
    id: _.SCOTIA_BANK,
    countries: ['PE'],
    is_available: false,
  },
  [_.INTERBAN]: {
    code: 73,
    name: 'InterBan',
    label: 'InterBan',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.INTERBAN,
    id: _.INTERBAN,
    countries: ['PE'],
    is_available: false,
  },
  [_.ALIA_CARD]: {
    code: 67,
    name: 'alia card',
    label: 'alia card',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.ALIA_CARD,
    api_name: _.ALIA_CARD,
    id: _.ALIA_CARD,
    countries: ['EC'],
    is_available: false,
  },
  [_.BANCARD]: {
    code: 69,
    name: 'Bancard',
    label: 'Bancard',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.BANCARD,
    id: _.BANCARD,
    countries: ['PY'],
    is_available: false,
  },
  [_.PSE]: {
    code: 66,
    name: 'PSE',
    label: 'PSE',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.PSE,
    id: _.PSE,
    countries: ['CO'],
    is_available: false,
  },
  [_.RED_PAGOS]: {
    code: 75,
    name: 'Red Pagos',
    label: 'Red Pagos',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.RED_PAGOS,
    id: _.RED_PAGOS,
    countries: ['UY'],
    is_available: false,
  },
  [_.WESTERN_UNION]: {
    code: 71,
    name: 'Western Union',
    label: 'Western Union',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.WESTERN_UNION,
    id: _.WESTERN_UNION,
    countries: ['PE'],
    is_available: false,
  },
  [_.BALOTO]: {
    code: 65,
    name: 'Baloto',
    label: 'Baloto',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.BALOTO,
    id: _.BALOTO,
    countries: ['CO'],
    logo: 'baloto.svg',
    logo_png: 'baloto.png',
    logo_colorbg: 'Baloto_colorbg.svg',
    logo_colorbg_png: 'Baloto_colorbg@2x.png',
    logo_favicon_colorbg: 'Baloto_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Baloto_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Baloto_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Baloto_favicon_whitebg@2x.png',
    logo_white: 'Baloto_white.svg',
    logo_white_png: 'Baloto_white@2x.png',
    logo_whitebg: 'Baloto_whitebg.svg',
    logo_whitebg_png: 'Baloto_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_form_fields: [
      {
        name: 'customer_identification_number',
        label: 'customer_identification_number',
        display_name: 'Cédula de Cuidadania (CC)',
        data_type: 'integer',
        example: '98754568543',
      },
    ],
    api_required_fields: [
      'payment_method_name',
      'amount',
      'currency',
      'customer_first_name',
      'customer_last_name',
      'customer_email',
      'customer_identification_number',
    ],
    component_type: ComponentTypes.FORM_REDIRECT,
  },
  [_.CORDIAL]: {
    code: 55,
    name: 'cordial',
    label: 'cordial',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.CORDIAL,
    api_name: _.CORDIAL,
    id: _.CORDIAL,
    countries: ['AR'],
    is_available: false,
  },
  [_.CITI]: {
    code: 43,
    name: 'Citi',
    label: 'Citi',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.CITI,
    id: _.CITI,
    countries: ['AR'],
    is_available: false,
  },
  [_.WEB_PAY]: {
    code: 59,
    name: 'Web Pay',
    label: 'Web Pay',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.WEB_PAY,
    id: _.WEB_PAY,
    countries: ['CL'],
    is_available: false,
  },
  [_.CABAL]: {
    code: 50,
    name: 'cabal',
    label: 'cabal',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.CABAL,
    api_name: _.CABAL,
    id: _.CABAL,
    countries: ['AR'],
    is_available: false,
  },
  [_.NARANJA]: {
    code: 52,
    name: 'naranja',
    label: 'naranja',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.NARANJA,
    api_name: _.NARANJA,
    id: _.NARANJA,
    countries: ['AR'],
    is_available: false,
  },
  [_.MACRO]: {
    code: 44,
    name: 'Macro',
    label: 'Macro',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.MACRO,
    id: _.MACRO,
    countries: ['AR'],
    is_available: false,
  },
  [_.HSBC]: {
    code: 46,
    name: 'HSBC',
    label: 'HSBC',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.HSBC,
    id: _.HSBC,
    countries: ['AR'],
    is_available: false,
  },
  [_.RED_COMPRA]: {
    code: 60,
    name: 'Red Compra',
    label: 'Red Compra',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.RED_COMPRA,
    id: _.RED_COMPRA,
    countries: ['CL'],
    is_available: false,
  },
  [_.CREDIT_COOP]: {
    code: 45,
    name: 'CreditCoop',
    label: 'CreditCoop',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.CREDIT_COOP,
    id: _.CREDIT_COOP,
    countries: ['AR'],
    is_available: false,
  },
  [_.ARGENCARD]: {
    code: 49,
    name: 'argencard',
    label: 'argencard',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.ARGENCARD,
    api_name: _.ARGENCARD,
    id: _.ARGENCARD,
    countries: ['AR'],
    is_available: false,
  },
  [_.GALICIA]: {
    code: 47,
    name: 'Galicia',
    label: 'Galicia',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.GALICIA,
    id: _.GALICIA,
    countries: ['AR'],
    is_available: false,
  },
  [_.NATIVA]: {
    code: 56,
    name: 'nativa',
    label: 'nativa',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.NATIVA,
    api_name: _.NATIVA,
    id: _.NATIVA,
    countries: ['AR'],
    is_available: false,
  },
  [_.CARDOBESA]: {
    code: 54,
    name: 'cardobesa',
    label: 'cardobesa',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.CARDOBESA,
    api_name: _.CARDOBESA,
    id: _.CARDOBESA,
    countries: ['AR'],
    is_available: false,
  },
  [_.TARJETA_SHOPPING]: {
    code: 57,
    name: 'tarjeta shopping',
    label: 'tarjeta shopping',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.TARJETA_SHOPPING,
    api_name: _.TARJETA_SHOPPING,
    id: _.TARJETA_SHOPPING,
    countries: ['AR'],
    is_available: false,
  },
  [_.CENCOSUD]: {
    code: 53,
    name: 'cencosud',
    label: 'cencosud',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.CENCOSUD,
    api_name: _.CENCOSUD,
    id: _.CENCOSUD,
    countries: ['AR'],
    is_available: false,
  },
  [_.EFECTY]: {
    code: 63,
    name: 'Efecty',
    label: 'Efecty',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.EFECTY,
    id: _.EFECTY,
    countries: ['CO'],
    is_available: false,
  },
  [_.PRESTO]: {
    code: 61,
    name: 'presto',
    label: 'presto',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.PRESTO,
    api_name: _.PRESTO,
    id: _.PRESTO,
    countries: ['CL'],
    is_available: false,
  },
  [_.SPEI]: {
    code: 39,
    name: 'SPEI',
    label: 'SPEI',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.SPEI,
    id: _.SPEI,
    countries: ['MX'],
    is_available: false,
  },
  [_.SERVI_PAGO]: {
    code: 58,
    name: 'Servi Pago',
    label: 'Servi Pago',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.SERVI_PAGO,
    id: _.SERVI_PAGO,
    countries: ['CL'],
    is_available: false,
  },
  [_.BANCO_PROVINCIA]: {
    code: 42,
    name: 'Banco Provincia',
    label: 'Banco Provincia',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BANCO_PROVINCIA,
    id: _.BANCO_PROVINCIA,
    countries: ['AR'],
    is_available: false,
  },
  [_.CMR_FALABELLA]: {
    code: 51,
    name: 'cmr falabella',
    label: 'cmr falabella',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.CMR_FALABELLA,
    api_name: _.CMR_FALABELLA,
    id: _.CMR_FALABELLA,
    countries: ['AR', 'CL'],
    is_available: false,
  },
  [_.DAVIVIENDA]: {
    code: 64,
    name: 'Davivienda',
    label: 'Davivienda',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.DAVIVIENDA,
    id: _.DAVIVIENDA,
    countries: ['CO'],
    is_available: false,
  },
  [_.BANCO_NACION]: {
    code: 48,
    name: 'Banco Nacion',
    label: 'Banco Nacion',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BANCO_NACION,
    id: _.BANCO_NACION,
    countries: ['AR'],
    is_available: false,
  },
  [_.MAGNA]: {
    code: 62,
    name: 'magna',
    label: 'magna',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.MAGNA,
    api_name: _.MAGNA,
    id: _.MAGNA,
    countries: ['CL'],
    is_available: false,
  },
  [_.PAGO_FACIL]: {
    code: 40,
    name: 'Pago Facil',
    label: 'Pago Facil',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.PAGO_FACIL,
    id: _.PAGO_FACIL,
    countries: ['AR'],
    logo: 'pago_facil.svg',
    logo_png: 'pago_facil.png',
    logo_colorbg: 'PagoFacil_colorbg.svg',
    logo_colorbg_png: 'PagoFacil_colorbg@2x.png',
    logo_favicon_colorbg: 'PagoFacil_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'PagoFacil_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'PagoFacil_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'PagoFacil_favicon_whitebg@2x.png',
    logo_white: 'PagoFacil_white.svg',
    logo_white_png: 'PagoFacil_white@2x.png',
    logo_whitebg: 'PagoFacil_whitebg.svg',
    logo_whitebg_png: 'PagoFacil_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_form_fields: [
      {
        name: 'customer_identification_number',
        label: 'customer_identification_number',
        display_name: 'DNI or CUIT',
        data_type: 'integer',
        example: '98754568543',
      },
    ],
    api_required_fields: [
      'payment_method_name',
      'amount',
      'currency',
      'customer_first_name',
      'customer_last_name',
      'customer_email',
      'customer_identification_number',
    ],
    component_type: ComponentTypes.FORM_REDIRECT,
  },
  [_.RAPI_PAGO]: {
    code: 41,
    name: 'Rapi Pago',
    label: 'Rapi Pago',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.RAPI_PAGO,
    id: _.RAPI_PAGO,
    countries: ['AR'],
    logo: 'rapi_pago.svg',
    logo_png: 'rapi_pago.png',
    logo_colorbg: 'RapiPago_colorbg.svg',
    logo_colorbg_png: 'RapiPago_colorbg@2x.png',
    logo_favicon_colorbg: 'RapiPago_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'RapiPago_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'RapiPago_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'RapiPago_favicon_whitebg@2x.png',
    logo_white: 'RapiPago_white.svg',
    logo_white_png: 'RapiPago_white@2x.png',
    logo_whitebg: 'RapiPago_whitebg.svg',
    logo_whitebg_png: 'RapiPago_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_form_fields: [
      {
        name: 'customer_identification_number',
        label: 'customer_identification_number',
        display_name: 'DNI or CUIT',
        data_type: 'integer',
        example: '98754568543',
      },
    ],
    api_required_fields: [
      'payment_method_name',
      'amount',
      'currency',
      'customer_first_name',
      'customer_last_name',
      'customer_email',
      'customer_identification_number',
    ],
    component_type: ComponentTypes.FORM_REDIRECT,
  },
  [_.BANORTE]: {
    code: 37,
    name: 'Banorte',
    label: 'Banorte',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BANORTE,
    id: _.BANORTE,
    countries: ['MX'],
    is_available: false,
  },
  [_.ELO]: {
    code: 27,
    name: 'elo',
    label: 'elo',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.ELO,
    api_name: _.ELO,
    id: _.ELO,
    countries: ['BR'],
    is_available: false,
  },
  [_.ITAU]: {
    code: 34,
    name: 'Itau',
    label: 'Itau',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.ITAU,
    id: _.ITAU,
    countries: ['AR', 'BR'],
    is_available: false,
  },
  [_.BRADESCO]: {
    code: 33,
    name: 'Bradesco',
    label: 'Bradesco',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BRADESCO,
    id: _.BRADESCO,
    countries: ['BR'],
    is_available: false,
  },
  [_.AURA]: {
    code: 30,
    name: 'aura',
    label: 'aura',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.AURA,
    api_name: _.AURA,
    id: _.AURA,
    countries: ['BR'],
    is_available: false,
  },
  [_.BBVA_BANCOMER]: {
    code: 38,
    name: 'BBVA Bancomer',
    label: 'BBVA Bancomer',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BBVA_BANCOMER,
    id: _.BBVA_BANCOMER,
    countries: ['MX', 'AR', 'PE'],
    is_available: false,
  },
  [_.MERCADO_LIVRE]: {
    code: 29,
    name: 'mercado Livre',
    label: 'mercado Livre',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.MERCADO_LIVRE,
    api_name: _.MERCADO_LIVRE,
    id: _.MERCADO_LIVRE,
    countries: ['BR'],
    is_available: false,
  },
  [_.BANCO_DO_BRASIL]: {
    code: 35,
    name: 'Banco do Brasil',
    label: 'Banco do Brasil',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BANCO_DO_BRASIL,
    id: _.BANCO_DO_BRASIL,
    countries: ['BR'],
    is_available: false,
  },
  [_.HIPERCARD]: {
    code: 28,
    name: 'hipercard',
    label: 'hipercard',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.HIPERCARD,
    api_name: _.HIPERCARD,
    id: _.HIPERCARD,
    countries: ['BR'],
    is_available: false,
  },
  [_.SANTANDER]: {
    code: 32,
    name: 'Santander',
    label: 'Santander',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.SANTANDER,
    id: _.SANTANDER,
    countries: ['AR', 'MX', 'BR'],
    is_available: false,
  },
  [_.CAIXA]: {
    code: 31,
    name: 'Caixa',
    label: 'Caixa',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.CAIXA,
    id: _.CAIXA,
    countries: ['BR'],
    is_available: false,
  },
  [_.BOLETO]: {
    code: 26,
    name: 'Boleto',
    label: 'Boleto',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.BOLETO,
    id: _.BOLETO,
    countries: ['BR'],
    logo: 'boleto.svg',
    logo_png: 'boleto.png',
    logo_colorbg: 'Boleto_colorbg.svg',
    logo_colorbg_png: 'Boleto_colorbg@2x.png',
    logo_favicon_colorbg: 'Boleto_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Boleto_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Boleto_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Boleto_favicon_whitebg@2x.png',
    logo_white: 'Boleto_white.svg',
    logo_white_png: 'Boleto_white@2x.png',
    logo_whitebg: 'Boleto_whitebg.svg',
    logo_whitebg_png: 'Boleto_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_form_fields: [
      {
        name: 'customer_identification_number',
        label: 'customer_identification_number',
        display_name: 'CPF or CNPF',
        data_type: 'integer',
        example: '53033315550',
      },
    ],
    api_required_fields: [
      'payment_method_name',
      'amount',
      'currency',
      'customer_first_name',
      'customer_last_name',
      'customer_email',
      'customer_country',
      'customer_identification_number',
    ],
    component_type: ComponentTypes.FORM_REDIRECT,
  },
  [_.OXXO]: {
    code: 36,
    name: 'Oxxo',
    label: 'Oxxo',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.OXXO,
    id: _.OXXO,
    countries: ['MX'],
    logo: 'oxxo.svg',
    logo_png: 'oxxo.png',
    logo_colorbg: 'Oxxo_colorbg.svg',
    logo_colorbg_png: 'Oxxo_colorbg@2x.png',
    logo_favicon_colorbg: 'Oxxo_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Oxxo_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Oxxo_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Oxxo_favicon_whitebg@2x.png',
    logo_white: 'Oxxo_white.svg',
    logo_white_png: 'Oxxo_white@2x.png',
    logo_whitebg: 'Oxxo_whitebg.svg',
    logo_whitebg_png: 'Oxxo_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_form_fields: [
      {
        name: 'customer_identification_number',
        label: 'customer_identification_number',
        display_name: 'CURP',
        data_type: 'integer',
        example: '456786543',
      },
    ],
    api_required_fields: [
      'payment_method_name',
      'amount',
      'currency',
      'customer_first_name',
      'customer_last_name',
      'customer_email',
      'customer_country',
      'customer_identification_number',
    ],
    component_type: ComponentTypes.FORM_REDIRECT,
  },
  [_.BACS]: {
    code: 19,
    name: 'BACS Direct Debit',
    label: 'BACS Direct Debit',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BACS,
    id: _.BACS,
    countries: ['GB'],
    is_available: false,
  },
  [_.ZIP]: {
    code: 22,
    name: 'Zip',
    label: 'Zip',
    type: PaymentMethodTypes.INSTALMENTS,
    scheme: Schemes._,
    api_name: _.ZIP,
    id: _.ZIP,
    countries: ['AU', 'NZ'],
    is_available: false,
  },
  [_.CUP]: {
    code: 17,
    name: 'China Union Pay',
    label: 'China Union Pay',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.CUP,
    createdBy: null,
    api_name: _.CUP,
    logo: 'cup.svg',
    logo_png: 'cup.png',
    logo_colorbg: 'UnionPay_colorbg.svg',
    logo_colorbg_png: 'UnionPay_colorbg@2x.png',
    logo_favicon_colorbg: 'UnionPay_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'UnionPay_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'UnionPay_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'UnionPay_favicon_whitebg@2x.png',
    logo_white: 'UnionPay_white.svg',
    logo_white_png: 'UnionPay_white@2x.png',
    logo_whitebg: 'UnionPay_whitebg.svg',
    logo_whitebg_png: 'UnionPay_whitebg@2x.png',
    id: _.CUP,
    countries: ['CN', 'HK', 'KR'],
    is_available: false,
  },
  [_.YANDEX]: {
    code: 15,
    name: 'Yandex',
    label: 'Yandex',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.YANDEX,
    id: _.YANDEX,
    is_available: false,
    countries: ['RU'],
  },
  [_.PAYPAL]: {
    code: 12,
    name: 'Paypal',
    label: 'Paypal',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.PAYPAL,
    id: _.PAYPAL,
    is_available: true,
    countries: [
      'DZ',
      'AO',
      'BJ',
      'BW',
      'BF',
      'BI',
      'CM',
      'CA',
      'TD',
      'KM',
      'CR',
      'CZ',
      'DJ',
      'EG',
      'ER',
      'ET',
      'GA',
      'GM',
      'GN',
      'GW',
      'KE',
      'LS',
      'MG',
      'MW',
      'ML',
      'MR',
      'MU',
      'YT',
      'MA',
      'MZ',
      'NA',
      'NE',
      'NG',
      'QA',
      'QA',
      'RW',
      'BL',
      'ST',
      'SN',
      'SC',
      'SL',
      'SO',
      'ZA',
      'SJ',
      'TZ',
      'TG',
      'TN',
      'UG',
      'ZM',
      'ZW',
      'AI',
      'AG',
      'AR',
      'AW',
      'BS',
      'BB',
      'BZ',
      'BM',
      'BT',
      'BR',
      'IO',
      'CA',
      'KY',
      'CL',
      'CO',
      'CR',
      'DM',
      'DO',
      'EC',
      'SV',
      'FK',
      'GF',
      'GL',
      'GD',
      'GP',
      'GT',
      'GY',
      'HN',
      'JM',
      'MQ',
      'MX',
      'MS',
      'NL',
      'NI',
      'PA',
      'PY',
      'PE',
      'KN',
      'LC',
      'PM',
      'VC',
      'SR',
      'TT',
      'TM',
      'GB',
      'UY',
      'VE',
      'AM',
      'AU',
      'BH',
      'BT',
      'IO',
      'KH',
      'MG',
      'CK',
      'FJ',
      'PF',
      'HK',
      'IN',
      'ID',
      'IL',
      'JP',
      'JO',
      'KZ',
      'KI',
      'KW',
      'KG',
      'LA',
      'MY',
      'MV',
      'MH',
      'FO',
      'MN',
      'NR',
      'NP',
      'NC',
      'NZ',
      'NU',
      'NF',
      'OM',
      'PW',
      'PG',
      'PH',
      'PN',
      'QA',
      'WS',
      'SA',
      'SG',
      'SB',
      'GS',
      'LK',
      'TW',
      'TJ',
      'TH',
      'TO',
      'TM',
      'TV',
      'AE',
      'VU',
      'VN',
      'WF',
      'YE',
      'AL',
      'AD',
      'AT',
      'AZ',
      'BY',
      'BE',
      'BA',
      'BG',
      'HR',
      'CY',
      'CZ',
      'DK',
      'EE',
      'FO',
      'FI',
      'FR',
      'GE',
      'DE',
      'GI',
      'GR',
      'HU',
      'IS',
      'IE',
      'IT',
      'LV',
      'LI',
      'LT',
      'LU',
      'MK',
      'MT',
      'MD',
      'MC',
      'ME',
      'NL',
      'NO',
      'PL',
      'PT',
      'RO',
      'RO',
      'SM',
      'RS',
      'SK',
      'SI',
      'ES',
      'SJ',
      'SE',
      'CH',
      'UA',
      'GB',
      'VU',
    ],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    logo: 'paypal.svg',
    logo_png: 'paypal.png',
    logo_colorbg: 'PayPal_colorbg.svg',
    logo_colorbg_png: 'PayPal_colorbg@2x.png',
    logo_favicon_colorbg: 'PayPal_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'PayPal_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'PayPal_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'PayPal_favicon_whitebg@2x.png',
    logo_white: 'PayPal_white.svg',
    logo_white_png: 'PayPal_white@2x.png',
    logo_whitebg: 'PayPal_whitebg.svg',
    logo_whitebg_png: 'PayPal_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    api_required_fields: ['amount', 'currency', 'payment_method_name'],
  },
  [_.ALIPAY]: {
    code: 16,
    name: 'Alipay',
    label: 'Alipay',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.ALIPAY,
    id: _.ALIPAY,
    is_available: true,
    countries: ['CN', 'HK'],
    logo: 'alipay.svg',
    logo_png: 'alipay.png',
    logo_colorbg: 'Alipay_colorbg.svg',
    logo_colorbg_png: 'Alipay_colorbg@2x.png',
    logo_favicon_colorbg: 'Alipay_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Alipay_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Alipay_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Alipay_favicon_whitebg@2x.png',
    logo_white: 'Alipay_white.svg',
    logo_white_png: 'Alipay_white@2x.png',
    logo_whitebg: 'Alipay_whitebg.svg',
    logo_whitebg_png: 'Alipay_whitebg@2x.png',
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.QIWI]: {
    code: 14,
    name: 'Qiwi',
    label: 'Qiwi',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.QIWI,
    id: _.QIWI,
    is_available: false,
    countries: ['RU'],
  },
  [_.AFTERPAY]: {
    code: 21,
    name: 'AfterPay',
    label: 'AfterPay',
    type: PaymentMethodTypes.OPEN_INVOICE,
    scheme: Schemes._,
    api_name: _.AFTERPAY,
    id: _.AFTERPAY,
    countries: ['NZ', 'AU'],
    is_available: false,
  },
  [_.WE_CHAT]: {
    code: 18,
    name: 'We Chat',
    label: 'We Chat',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.WE_CHAT,
    id: _.WE_CHAT,
    countries: ['CN', 'HK'],
    is_available: true,
    logo: 'wechat.svg',
    logo_png: 'wechat.png',
    logo_colorbg: 'WeChat_colorbg.svg',
    logo_colorbg_png: 'WeChat_colorbg@2x.png',
    logo_favicon_colorbg: 'WeChat_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'WeChat_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'WeChat_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'WeChat_favicon_whitebg@2x.png',
    logo_white: 'WeChat_white.svg',
    logo_white_png: 'WeChat_white@2x.png',
    logo_whitebg: 'WeChat_whitebg.svg',
    logo_whitebg_png: 'WeChat_whitebg@2x.png',
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.INTERAC]: {
    code: 24,
    name: 'Interac',
    label: 'Interac',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.INTERAC,
    id: _.INTERAC,
    countries: ['CA'],
    is_available: false,
  },
  [_.INTERAC_CARD]: {
    code: 112,
    name: 'Interac card',
    label: 'Interac card',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.INTERAC,
    api_name: _.INTERAC_CARD,
    id: _.INTERAC_CARD,
    countries: ['CA'],
    is_available: false,
  },
  [_.JCB]: {
    code: 23,
    name: 'JCB',
    label: 'JCB',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.JCB,
    api_name: _.JCB,
    id: _.JCB,
    countries: ['KR', 'IN', 'PH', 'JP'],
    is_available: true,
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    component_type: ComponentTypes.CARD,
    logo: 'jcb.svg',
    logo_png: 'jcb.png',
    logo_colorbg: 'JCB_colorbg.svg',
    logo_colorbg_png: 'JCB_colorbg@2x.png',
    logo_favicon_colorbg: 'JCB_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'JCB_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'JCB_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'JCB_favicon_whitebg@2x.png',
    logo_white: 'JCB_white.svg',
    logo_white_png: 'JCB_white@2x.png',
    logo_whitebg: 'JCB_whitebg.svg',
    logo_whitebg_png: 'JCB_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '3528 xxxx xxxx xxxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '123',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
  },
  [_.SOFORT]: {
    code: 7,
    name: 'Sofort',
    label: 'Sofort',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.SOFORT,
    id: _.SOFORT,
    countries: ['CH', 'DE'],
    logo: 'sofort.svg',
    logo_png: 'sofort.png',
    logo_colorbg: 'Sofort_colorbg.svg',
    logo_colorbg_png: 'Sofort_colorbg@2x.png',
    logo_favicon_colorbg: 'Sofort_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Sofort_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Sofort_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Sofort_favicon_whitebg@2x.png',
    logo_white: 'Sofort_white.svg',
    logo_white_png: 'Sofort_white@2x.png',
    logo_whitebg: 'Sofort_whitebg.svg',
    logo_whitebg_png: 'Sofort_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
  },
  [_.GIROPAY]: {
    code: 8,
    name: 'Giropay',
    label: 'Giropay',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.GIROPAY,
    id: _.GIROPAY,
    countries: ['DE'],
    logo: 'giropay.svg',
    logo_png: 'giropay.png',
    logo_colorbg: 'Giropay_colorbg.svg',
    logo_colorbg_png: 'Giropay_colorbg@2x.png',
    logo_favicon_colorbg: 'Giropay_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Giropay_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Giropay_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Giropay_favicon_whitebg@2x.png',
    logo_white: 'Giropay_white.svg',
    logo_white_png: 'Giropay_white@2x.png',
    logo_whitebg: 'Giropay_whitebg.svg',
    logo_whitebg_png: 'Giropay_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_required_fields: ['payment_method_name', 'amount', 'currency', 'product_description'],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.KLARNA]: {
    code: 9,
    name: 'Klarna',
    label: 'Klarna',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    countries: ['SE', 'NO', 'FI', 'DK', 'DE', 'AT', 'NL', 'BE', 'CH', 'FR', 'IT', 'PL', 'ES', 'PT', 'GB', 'HU', 'CZ', 'SK', 'US', 'AU'],
    api_name: _.KLARNA,
    id: _.KLARNA,
    logo: 'klarna.svg',
    logo_png: 'klarna.png',
    logo_colorbg: 'Klarna_colorbg.svg',
    logo_colorbg_png: 'Klarna_colorbg@2x.png',
    logo_favicon_colorbg: 'Klarna_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Klarna_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Klarna_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Klarna_favicon_whitebg@2x.png',
    logo_white: 'Klarna_white.svg',
    logo_white_png: 'Klarna_white@2x.png',
    logo_whitebg: 'Klarna_whitebg.svg',
    logo_whitebg_png: 'Klarna_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_required_fields: ['payment_method_name', 'amount', 'currency', 'token'],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.APPLEPAY]: {
    code: 132,
    name: 'Apple Pay',
    label: 'Apple Pay',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    countries: [
      'AR',
      'AM',
      'AU',
      'AT',
      'AZ',
      'BH',
      'BY',
      'BE',
      'BR',
      'BG',
      'CA',
      'CN',
      'CO',
      'CR',
      'HR',
      'CY',
      'CZ',
      'DK',
      'EE',
      'FO',
      'FI',
      'FR',
      'GE',
      'DE',
      'GR',
      'GL',
      'GG',
      'HK',
      'HU',
      'IS',
      'IE',
      'IM',
      'IL',
      'IT',
      'JP',
      'JE',
      'KZ',
      'LV',
      'LI',
      'LT',
      'LU',
      'MO',
      'MT',
      'MX',
      'MD',
      'MC',
      'ME',
      'NL',
      'NZ',
      'NO',
      'PS',
      'PE',
      'PL',
      'PT',
      'QA',
      'RO',
      'SM',
      'SA',
      'RS',
      'SG',
      'SK',
      'SI',
      'ZA',
      'ES',
      'SE',
      'CH',
      'TW',
      'UA',
      'AE',
      'GB',
      'US',
    ],
    api_name: _.APPLEPAY,
    id: _.APPLEPAY,
    logo: 'apple_pay.svg',
    logo_png: 'apple_pay.png',
    logo_colorbg: 'ApplePay_colorbg.svg',
    logo_colorbg_png: 'ApplePay_colorbg@2x.png',
    logo_favicon_colorbg: 'ApplePay_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'ApplePay_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'ApplePay_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'ApplePay_favicon_whitebg@2x.png',
    logo_white: 'ApplePay_white.svg',
    logo_white_png: 'ApplePay_white@2x.png',
    logo_whitebg: 'ApplePay_whitebg.svg',
    logo_whitebg_png: 'ApplePay_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.BANCONTACT]: {
    code: 10,
    name: 'Bancontact',
    label: 'Bancontact',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes.BANCONTACT,
    api_name: _.BANCONTACT,
    id: _.BANCONTACT,
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
    countries: ['BE'],
    logo: 'bancontact.svg',
    logo_png: 'bancontact.png',
    logo_colorbg: 'Bancontact_colorbg.svg',
    logo_colorbg_png: 'Bancontact_colorbg@2x.png',
    logo_favicon_colorbg: 'Bancontact_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Bancontact_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Bancontact_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Bancontact_favicon_whitebg@2x.png',
    logo_white: 'Bancontact_white.svg',
    logo_white_png: 'Bancontact_white@2x.png',
    logo_whitebg: 'Bancontact_whitebg.svg',
    logo_whitebg_png: 'Bancontact_whitebg@2x.png',
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '6703 xxxx xxxx xxxxxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '123',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.IDEAL]: {
    code: 11,
    name: 'Ideal',
    label: 'Ideal',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.IDEAL,
    id: _.IDEAL,
    countries: ['NL'],
    logo: 'ideal.svg',
    logo_png: 'ideal.png',
    logo_colorbg: 'IDeal_colorbg.svg',
    logo_colorbg_png: 'IDeal_colorbg@2x.png',
    logo_favicon_colorbg: 'IDeal_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'IDeal_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'IDeal_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'IDeal_favicon_whitebg@2x.png',
    logo_white: 'IDeal_white.svg',
    logo_white_png: 'IDeal_white@2x.png',
    logo_whitebg: 'iDeal_whitebg.svg',
    logo_whitebg_png: 'iDeal_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.FORM_REDIRECT,
    api_required_fields: ['payment_method_name', 'amount', 'currency', 'account_bic'],
    api_form_fields: [
      {
        name: 'account_bic',
        label: 'account_bic',
        display_name: 'Bank name',
        data_type: 'string',
        enum: [
          {
            key: 'ABNANL2A',
            value: 'ABN AMRO',
          },
          {
            key: 'ASNBNL21',
            value: 'ASN Bank',
          },
          {
            key: 'BUNQNL2A',
            value: 'bunq',
          },
          {
            key: 'HANDNL2A',
            value: 'Handelsbanken',
          },
          {
            key: 'INGBNL2A',
            value: 'ING',
          },
          {
            key: 'KNABNL2H',
            value: 'Knab',
          },
          {
            key: 'RABONL2U',
            value: 'Rabobank',
          },
          {
            key: 'RBRBNL21',
            value: 'RegioBank',
          },
          {
            key: 'REVOLT21',
            value: 'Revolut',
          },
          {
            key: 'SNSBNL2A',
            value: 'SNS',
          },
          {
            key: 'TRIONL2U',
            value: 'Triodos Bank',
          },
          {
            key: 'FVLBNL22',
            value: 'Van Lanschot',
          },
        ],
        example: 'INGBNL2A',
      },
    ],
  },
  [_.MULTIBANCO]: {
    code: 13,
    name: 'Multibanco',
    label: 'Multibanco',
    type: PaymentMethodTypes.ON_REFERENCE,
    scheme: Schemes._,
    api_name: _.MULTIBANCO,
    id: _.MULTIBANCO,
    countries: ['PT'],
    logo: 'multibanco.svg',
    logo_png: 'multibanco.png',
    logo_colorbg: 'Multibanco_colorbg.svg',
    logo_colorbg_png: 'Multibanco_colorbg@2x.png',
    logo_favicon_colorbg: 'Multibanco_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Multibanco_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Multibanco_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Multibanco_favicon_whitebg@2x.png',
    logo_white: 'Multibanco_white.svg',
    logo_white_png: 'Multibanco_white@2x.png',
    logo_whitebg: 'Multibanco_whitebg.svg',
    logo_whitebg_png: 'Multibanco_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_required_fields: ['payment_method_name', 'amount', 'currency', 'account_holder_first_name', 'account_holder_last_name'],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.POLI]: {
    code: 20,
    name: 'POLi',
    label: 'POLi',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.POLI,
    id: _.POLI,
    countries: ['AU', 'NZ'],
    logo: 'poli.svg',
    logo_png: 'poli.png',
    logo_colorbg: 'Poli_colorbg.svg',
    logo_colorbg_png: 'Poli_colorbg@2x.png',
    logo_favicon_colorbg: 'Poli_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Poli_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Poli_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Poli_favicon_whitebg@2x.png',
    logo_white: 'Poli_white.svg',
    logo_white_png: 'Poli_white@2x.png',
    logo_whitebg: 'Poli_whitebg.svg',
    logo_whitebg_png: 'Poli_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.DISCOVER]: {
    code: 25,
    name: 'Discover',
    label: 'Discover',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.DISCOVER,
    api_name: _.DISCOVER,
    id: _.DISCOVER,
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    countries: ['US', 'BR'],
    logo: 'discover.svg',
    logo_png: 'discover.png',
    logo_colorbg: 'Discover_colorbg.svg',
    logo_colorbg_png: 'Discover_colorbg@2x.png',
    logo_favicon_colorbg: 'Discover_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Discover_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Discover_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Discover_favicon_whitebg@2x.png',
    logo_white: 'Discover_white.svg',
    logo_white_png: 'Discover_white@2x.png',
    logo_whitebg: 'Discover_whitebg.svg',
    logo_whitebg_png: 'Discover_whitebg@2x.png',
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '9500 xxxx xxxx xxxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '123',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.CARD,
  },
  [_.GARANTIPAY]: {
    code: 129,
    name: 'GarantiPay',
    label: 'GarantiPay',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.GARANTIPAY,
    id: _.GARANTIPAY,
    countries: ['TR'],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    api_required_fields: ['amount', 'currency', 'payment_method_name', 'customer_email'],
    logo: 'garantipay.svg',
    logo_png: 'garantipay.png',
    logo_colorbg: 'GarantiPay_colorbg.svg',
    logo_colorbg_png: 'GarantiPay_colorbg@2x.png',
    logo_favicon_colorbg: 'GarantiPay_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'GarantiPay_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'GarantiPay_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'GarantiPay_favicon_whitebg@2x.png',
    logo_white: 'GarantiPay_white.svg',
    logo_white_png: 'GarantiPay_white@2x.png',
    logo_whitebg: 'GarantiPay_whitebg.svg',
    logo_whitebg_png: 'GarantiPay_whitebg@2x.png',
  },
  [_.PAY_WITH_IYZICO]: {
    code: 130,
    name: 'Pay with Iyzico',
    label: 'Pay with Iyzico',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.PAY_WITH_IYZICO,
    id: _.PAY_WITH_IYZICO,
    countries: ['TR'],
    logo: 'iyzico.svg',
    logo_png: 'iyzico.png',
    logo_colorbg: 'Iyzico_colorbg.svg',
    logo_colorbg_png: 'Iyzico_colorbg@2x.png',
    logo_favicon_colorbg: 'Iyzico_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Iyzico_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Iyzico_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Iyzico_favicon_whitebg@2x.png',
    logo_white: 'Iyzico_white.svg',
    logo_white_png: 'Iyzico_white@2x.png',
    logo_whitebg: 'Iyzico_whitebg.svg',
    logo_whitebg_png: 'Iyzico_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
  },
  [_.J_DEBIT]: {
    code: 108,
    name: 'J-Debit',
    label: 'J-Debit',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.J_DEBIT,
    api_name: _.J_DEBIT,
    id: _.J_DEBIT,
    countries: ['JP'],
    is_available: false,
  },
  [_.SUPERCASH]: {
    code: 117,
    name: 'Supercash',
    label: 'Supercash',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.SUPERCASH,
    id: _.SUPERCASH,
    countries: ['CZ'],
    is_available: false,
  },
  [_.TRUE_MONEY]: {
    code: 115,
    name: 'True Money',
    label: 'True Money',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.TRUE_MONEY,
    id: _.TRUE_MONEY,
    countries: ['TH'],
    is_available: false,
  },
  [_.LOCAL_CARDS]: {
    code: 119,
    name: 'Local Cards',
    label: 'Local Cards',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes._,
    api_name: _.LOCAL_CARDS,
    id: _.LOCAL_CARDS,
    countries: ['KR', 'MA'],
    is_available: false,
  },
  [_.CASH]: {
    code: 105,
    name: 'Cash',
    label: 'Cash',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.CASH,
    id: _.CASH,
    countries: ['NO', 'PL', 'PH', 'RU', 'IE', 'US', 'HK', 'CA', 'AU', 'IN', 'ID', 'TH', 'KR', 'MY', 'ZA', 'MA', 'JP', 'PE', 'GR', 'ID', 'MX', 'VN'],
    is_available: false,
  },
  [_.EPS]: {
    code: 106,
    name: 'EPS',
    label: 'EPS',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.EPS,
    id: _.EPS,
    countries: ['AT'],
    is_available: true,
    api_required_fields: ['payment_method_name', 'amount', 'currency', 'product_description'],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    logo: 'eps.svg',
    logo_png: 'eps.png',
    logo_colorbg: 'EPS_colorbg.svg',
    logo_colorbg_png: 'EPS_colorbg@2x.png',
    logo_favicon_colorbg: 'EPS_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'EPS_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'EPS_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'EPS_favicon_whitebg@2x.png',
    logo_white: 'EPS_white.svg',
    logo_white_png: 'EPS_white@2x.png',
    logo_whitebg: 'EPS_whitebg.svg',
    logo_whitebg_png: 'EPS_whitebg@2x.png',
  },
  [_.NPAY]: {
    code: 116,
    name: 'Npay',
    label: 'Npay',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.NPAY,
    id: _.NPAY,
    countries: ['KR'],
    is_available: false,
  },
  [_.QPAY]: {
    code: 124,
    name: 'QPay',
    label: 'QPay',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.QPAY,
    id: _.QPAY,
    countries: ['QA'],
    is_available: false,
  },
  [_.BANCNET]: {
    code: 110,
    name: 'Bancnet',
    label: 'Bancnet',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.BANCNET,
    api_name: _.BANCNET,
    id: _.BANCNET,
    countries: ['PH'],
    is_available: false,
  },
  [_.KNET]: {
    code: 123,
    name: 'KNET',
    label: 'KNET',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes._,
    api_name: _.KNET,
    id: _.KNET,
    countries: ['KU'],
    is_available: false,
  },
  [_.DOKU_WALLET]: {
    code: 113,
    name: 'Doku Wallet',
    label: 'Doku Wallet',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.DOKU_WALLET,
    id: _.DOKU_WALLET,
    countries: ['ID'],
    is_available: false,
  },
  [_.NETS]: {
    code: 114,
    name: 'Nets',
    label: 'Nets',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.NETS,
    api_name: _.NETS,
    id: _.NETS,
    countries: ['SG'],
    is_available: false,
  },
  [_.MY_DEBIT]: {
    code: 120,
    name: 'MyDebit',
    label: 'MyDebit',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.MY_DEBIT,
    api_name: _.MY_DEBIT,
    id: _.MY_DEBIT,
    countries: ['MY'],
    is_available: false,
  },
  [_.MIR]: {
    code: 107,
    name: 'MIR',
    label: 'MIR',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.MIR,
    api_name: _.MIR,
    id: _.MIR,
    countries: ['RU'],
    is_available: false,
  },
  [_.BANK_TRANSFER]: {
    code: 118,
    name: 'Bank Transfer',
    label: 'Bank Transfer',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.BANK_TRANSFER,
    id: _.BANK_TRANSFER,
    countries: ['all'],
    logo: 'bank_transfer.svg',
    logo_png: 'bank_transfer.png',
    logo_colorbg: 'BankTransfer_colorbg.svg',
    logo_colorbg_png: 'BankTransfer_colorbg@2x.png',
    logo_favicon_colorbg: 'BankTransfer_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'BankTransfer_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'BankTransfer_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'BankTransfer_favicon_whitebg@2x.png',
    logo_white: 'BankTransfer_white.svg',
    logo_white_png: 'BankTransfer_white@2x.png',
    logo_whitebg: 'BankTransfer_whitebg.svg',
    logo_whitebg_png: 'BankTransfer_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.MOBILE_WALLETS]: {
    code: 121,
    name: 'Mobile Wallets',
    label: 'Mobile Wallets',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.MOBILE_WALLETS,
    id: _.MOBILE_WALLETS,
    countries: ['CL', 'ZA', 'VN', 'MY', 'MX', 'MA'],
    is_available: false,
  },
  [_.MADA]: {
    code: 125,
    name: 'Mada',
    label: 'Mada',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes._,
    api_name: _.MADA,
    id: _.MADA,
    countries: ['SA'],
    is_available: false,
  },
  [_.EPS_HK]: {
    code: 109,
    name: 'EPS',
    label: 'EPS',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.EPS,
    api_name: _.EPS_HK,
    id: _.EPS_HK,
    countries: ['HK'],
    is_available: false,
  },
  [_.P24]: {
    code: 122,
    name: 'Przelewy24',
    label: 'Przelewy24',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.P24,
    id: _.P24,
    countries: ['PO'],
    logo: 'p24.svg',
    logo_png: 'p24.png',
    logo_colorbg: 'P24_colorbg.svg',
    logo_colorbg_png: 'P24_colorbg@2x.png',
    logo_favicon_colorbg: 'P24_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'P24_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'P24_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'P24_favicon_whitebg@2x.png',
    logo_white: 'P24_white.svg',
    logo_white_png: 'P24_white@2x.png',
    logo_whitebg: 'P24_whitebg.svg',
    logo_whitebg_png: 'P24_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    api_required_fields: ['payment_method_name', 'amount', 'currency', 'account_holder_first_name', 'account_holder_last_name', 'customer_email'],
    component_type: ComponentTypes.NO_FORM_REDIRECT,
  },
  [_.MASTERCARD]: {
    code: 2,
    name: 'Mastercard',
    label: 'Mastercard',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.MASTERCARD,
    api_name: _.MASTERCARD,
    id: _.MASTERCARD,
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    countries: ['all'],
    logo: 'mastercard.svg',
    logo_png: 'mastercard.png',
    logo_colorbg: 'Mastercard_colorbg.svg',
    logo_colorbg_png: 'Mastercard_colorbg@2x.png',
    logo_favicon_colorbg: 'Mastercard_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Mastercard_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Mastercard_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Mastercard_favicon_whitebg@2x.png',
    logo_white: 'Mastercard_white.svg',
    logo_white_png: 'Mastercard_white@2x.png',
    logo_whitebg: 'Mastercard_whitebg.svg',
    logo_whitebg_png: 'Mastercard_whitebg@2x.png',
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '5436 xxxx xxxx xxxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '123',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.CARD,
  },
  [_.AMEX]: {
    code: 3,
    name: 'American Express',
    label: 'American Express',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.AMEX,
    createdBy: null,
    api_name: _.AMEX,
    id: _.AMEX,
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    countries: ['all'],
    logo: 'amex.svg',
    logo_png: 'amex.png',
    logo_colorbg: 'American-Express_colorbg.svg',
    logo_colorbg_png: 'American-Express_colorbg@2x.png',
    logo_favicon_colorbg: 'American-Express_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'American-Express_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'American-Express_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'American-Express_favicon_whitebg@2x.png',
    logo_white: 'American-Express_white.svg',
    logo_white_png: 'American-Express_white@2x.png',
    logo_whitebg: 'American-Express_whitebg.svg',
    logo_whitebg_png: 'American-Express_whitebg@2x.png',
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '3456 xxxx xxxx xxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '1234',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.CARD,
  },
  [_.CB]: {
    code: 4,
    name: 'Carte Bancaire',
    label: 'Carte Bancaire',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.CB,
    createdBy: null,
    api_name: _.CB,
    id: _.CB,
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    countries: ['FR'],
    logo: 'cb.svg',
    logo_png: 'cb.png',
    logo_colorbg: 'CB_colorbg.svg',
    logo_colorbg_png: 'CB_colorbg@2x.png',
    logo_favicon_colorbg: 'CB_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'CB_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'CB_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'CB_favicon_whitebg@2x.png',
    logo_white: 'CB_white.svg',
    logo_white_png: 'CB_white@2x.png',
    logo_whitebg: 'CB_whitebg.svg',
    logo_whitebg_png: 'CB_whitebg@2x.png',
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '5131 xxxx xxxx xxxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '123',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.CARD,
  },
  [_.MAESTRO]: {
    code: 5,
    name: 'Maestro',
    label: 'Maestro',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.MAESTRO,
    api_name: _.MAESTRO,
    id: _.MAESTRO,
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    countries: ['all'],
    logo: 'maestro.svg',
    logo_png: 'maestro.png',
    logo_colorbg: 'Maestro_colorbg.svg',
    logo_colorbg_png: 'Maestro_colorbg@2x.png',
    logo_favicon_colorbg: 'Maestro_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Maestro_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Maestro_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Maestro_favicon_whitebg@2x.png',
    logo_white: 'Maestro_white.svg',
    logo_white_png: 'Maestro_white@2x.png',
    logo_whitebg: 'Maestro_whitebg.svg',
    logo_whitebg_png: 'Maestro_whitebg@2x.png',
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '5600 xxxx xxxx xxxx xxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '123',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.CARD,
  },
  [_.SDD]: {
    code: 6,
    name: 'Sepa Direct Debit',
    label: 'Sepa Direct Debit',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.SDD,
    id: _.SDD,
    api_required_fields: ['payment_method_name', 'amount', 'currency', 'token'],
    countries: [
      'AX',
      'AT',
      'BE',
      'CY',
      'EE',
      'FI',
      'FR',
      'DE',
      'GR',
      'IE',
      'IT',
      'LV',
      'LT',
      'LU',
      'MT',
      'MC',
      'NL',
      'PT',
      'SM',
      'SK',
      'SI',
      'ES',
      'BG',
      'CZ',
      'DK',
      'GI',
      'HU',
      'IS',
      'LI',
      'NO',
      'PL',
      'RO',
      'SE',
      'CH',
    ],
    logo: 'sepa.svg',
    logo_png: 'sepa.png',
    logo_colorbg: 'SEPA_colorbg.svg',
    logo_colorbg_png: 'SEPA_colorbg@2x.png',
    logo_favicon_colorbg: 'SEPA_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'SEPA_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'SEPA_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'SEPA_favicon_whitebg@2x.png',
    logo_white: 'SEPA_white.svg',
    logo_white_png: 'SEPA_white@2x.png',
    logo_whitebg: 'SEPA_whitebg.svg',
    logo_whitebg_png: 'SEPA_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    has_standalone_authentication: true,
  },
  [_.VISA]: {
    code: 1,
    name: 'Visa',
    label: 'Visa',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.VISA,
    api_name: _.VISA,
    id: _.VISA,
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    countries: ['all'],
    logo: 'visa.svg',
    logo_png: 'visa.png',
    logo_colorbg: 'Visa_colorbg.svg',
    logo_colorbg_png: 'Visa_colorbg@2x.png',
    logo_favicon_colorbg: 'Visa_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Visa_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Visa_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Visa_favicon_whitebg@2x.png',
    logo_white: 'Visa_white.svg',
    logo_white_png: 'Visa_white@2x.png',
    logo_whitebg: 'Visa_whitebg.svg',
    logo_whitebg_png: 'Visa_whitebg@2x.png',
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '4111 xxxx xxxx xxxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '123',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.CARD,
  },
  [_.CIRRUS]: {
    code: 137,
    name: 'Cirrus',
    label: 'Cirrus',
    type: PaymentMethodTypes.CARD,
    scheme: Schemes.CIRRUS,
    api_name: _.CIRRUS,
    id: _.CIRRUS,
    api_required_fields: ['payment_method_name', 'token', 'amount', 'currency'],
    countries: ['all'],
    logo: 'cirrus.svg',
    logo_png: 'cirrus.png',
    logo_colorbg: 'Cirrus_colorbg.svg',
    logo_colorbg_png: 'Cirrus_colorbg@2x.png',
    logo_favicon_colorbg: 'Cirrus_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Cirrus_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Cirrus_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Cirrus_favicon_whitebg@2x.png',
    logo_white: 'Cirrus_white.svg',
    logo_white_png: 'Cirrus_white@2x.png',
    logo_whitebg: 'Cirrus_whitebg.svg',
    logo_whitebg_png: 'Cirrus_whitebg@2x.png',
    api_form_fields: [
      {
        name: 'card_number',
        label: 'card_number',
        display_name: 'card_number',
        data_type: 'integer',
        enum: [],
        example: '305x xxxx xxxx xxxx',
      },
      {
        name: 'cvc',
        label: 'cvc',
        display_name: 'cvc',
        data_type: 'integer',
        enum: [],
        example: '123',
      },
      {
        name: 'card_validity',
        label: 'card_validity',
        display_name: 'card_validity',
        data_type: 'date',
        enum: [],
        example: 'MM/YY',
      },
      {
        name: 'cardholder_name',
        label: 'cardholder_name',
        display_name: 'cardholder_name',
        data_type: 'name',
        enum: [],
        example: 'Mickael Smith',
      },
    ],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.CARD,
  },
  [_.MASTERPASS]: {
    code: 138,
    name: 'Masterpass',
    label: 'Masterpass',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes.MASTERPASS,
    api_name: _.MASTERPASS,
    id: _.MASTERPASS,
    api_required_fields: ['amount', 'currency', 'payment_method_name', 'customer_phone_number'],
    api_form_fields: [
      {
        name: 'customer_phone_number',
        label: 'customer_phone_number',
        display_name: 'Phone number',
        data_type: 'integer',
        example: '905461234561',
      },
    ],
    countries: ['TR'],
    component_type: ComponentTypes.FORM_REDIRECT,
    logo: 'masterpass.svg',
    logo_png: 'masterpass.png',
    logo_colorbg: 'Masterpass_colorbg.svg',
    logo_colorbg_png: 'Masterpass_colorbg@2x.png',
    logo_favicon_colorbg: 'Masterpass_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Masterpass_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Masterpass_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Masterpass_favicon_whitebg@2x.png',
    logo_white: 'Masterpass_white.svg',
    logo_white_png: 'Masterpass_white@2x.png',
    logo_whitebg: 'Masterpass_whitebg.svg',
    logo_whitebg_png: 'Masterpass_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
  },
  [_.CASHTOCODE]: {
    code: 136,
    name: 'CashtoCode',
    label: 'CashtoCode',
    type: PaymentMethodTypes.CASH,
    scheme: Schemes._,
    api_name: _.CASHTOCODE,
    id: _.CASHTOCODE,
    countries: ['AT', 'DE', 'IT', 'IE'],
    logo: 'cashtocode.svg',
    logo_png: 'cashtocode.png',
    logo_colorbg: 'Cashtocode_colorbg.svg',
    logo_colorbg_png: 'Cashtocode_colorbg@2x.png',
    logo_favicon_colorbg: 'Cashtocode_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Cashtocode_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Cashtocode_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Cashtocode_favicon_whitebg@2x.png',
    logo_white: 'Cashtocode_white.svg',
    logo_white_png: 'Cashtocode_white@2x.png',
    logo_whitebg: 'Cashtocode_whitebg.svg',
    logo_whitebg_png: 'Cashtocode_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
  },
  [_.BITCOIN]: {
    code: 139,
    name: 'Bitcoin',
    label: 'Bitcoin',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.BITCOIN,
    id: _.BITCOIN,
    countries: ['all'],
    logo: 'bitcoin.svg',
    logo_png: 'bitcoin.png',
    logo_colorbg: 'Bitcoin_colorbg.svg',
    logo_colorbg_png: 'Bitcoin_colorbg@2x.png',
    logo_favicon_colorbg: 'Bitcoin_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Bitcoin_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Bitcoin_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Bitcoin_favicon_whitebg@2x.png',
    logo_white: 'Bitcoin_white.svg',
    logo_white_png: 'Bitcoin_white@2x.png',
    logo_whitebg: 'Bitcoin_whitebg.svg',
    logo_whitebg_png: 'Bitcoin_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
    color: '#F79329',
    token: 'BTC',
    decimals: 8,
  },
  [_.ETHEREUM]: {
    code: 140,
    name: 'Ethereum',
    label: 'Ethereum',
    type: PaymentMethodTypes.E_WALLET,
    scheme: Schemes._,
    api_name: _.ETHEREUM,
    id: _.ETHEREUM,
    countries: ['all'],
    logo: 'ethereum.svg',
    logo_png: 'ethereum.png',
    logo_colorbg: 'Ethereum_colorbg.svg',
    logo_colorbg_png: 'Ethereum_colorbg@2x.png',
    logo_favicon_colorbg: 'Ethereum_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Ethereum_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Ethereum_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Ethereum_favicon_whitebg@2x.png',
    logo_white: 'Ethereum_white.svg',
    logo_white_png: 'Ethereum_white@2x.png',
    logo_whitebg: 'Ethereum_whitebg.svg',
    logo_whitebg_png: 'Ethereum_whitebg@2x.png',
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    api_required_fields: ['payment_method_name', 'amount', 'currency'],
    color: '#33314A',
    token: 'ETH',
    decimals: 18,
  },
  [_.PAYCONIQ]: {
    code: 141,
    name: 'Payconiq',
    label: 'Payconiq',
    type: PaymentMethodTypes.BANK_TRANSFER,
    scheme: Schemes._,
    api_name: _.PAYCONIQ,
    id: _.PAYCONIQ,
    countries: ['BE'],
    devices_available: [DeviceTypes.DESKTOP, DeviceTypes.LAPTOP, DeviceTypes.MOBILE],
    is_available: true,
    component_type: ComponentTypes.NO_FORM_REDIRECT,
    api_required_fields: ['amount', 'currency', 'payment_method_name'],
    logo: 'payconiq.svg',
    logo_png: 'payconiq.png',
    logo_colorbg: 'Payconiq_colorbg.svg',
    logo_colorbg_png: 'Payconiq_colorbg@2x.png',
    logo_favicon_colorbg: 'Payconiq_favicon_colorbg.svg',
    logo_favicon_colorbg_png: 'Payconiq_favicon_colorbg@2x.png',
    logo_favicon_whitebg: 'Payconiq_favicon_whitebg.svg',
    logo_favicon_whitebg_png: 'Payconiq_favicon_whitebg@2x.png',
    logo_white: 'Payconiq_white.svg',
    logo_white_png: 'Payconiq_white@2x.png',
    logo_whitebg: 'Payconiq_whitebg.svg',
    logo_whitebg_png: 'Payconiq_whitebg@2x.png',
  },
};

module.exports = paymentMethods;
